import {FULL_WIDTH_CHARACTERS, HALF_WIDTH_CHARACTERS, IOS_RESOURCE_FILENAME} from "../../constant";
import BaseResourceWriter from "./BaseResourceWriter";

export default class PhpLaravelResourceWriter extends BaseResourceWriter {
    constructor(languageCode,
                trimWhitespace,
                replacePlaceholders,
                replaceFullWidthPlaceholders,
                replaceWhitespaceCharacters,
                retainEmptyValue,
                header,
                name) {
        super(languageCode,
            trimWhitespace,
            replacePlaceholders,
            replaceFullWidthPlaceholders,
            replaceWhitespaceCharacters,
            retainEmptyValue,
            header);
        if (header) {
            this.name = name;
            this.stringBuilder = "<?php\n\n\nreturn [\n";
        }
    }

    write(key, value) {
        if (this.stringBuilder !== undefined) {
            let checkedKey = key.trim().replace(/\r\n/g, "_").replace(/\r/g, "_").replace(/\n/g, "_").replace(/"/g, "\\\"");
            if (!checkedKey) return;
            let checkedValue = value;
            if (this.trimWhitespace) checkedValue = checkedValue.trim();
            if (this.replaceWhitespaceCharacters) checkedValue = checkedValue.replace(/\\/g, "\\\\").replace(/\r\n/g, "<br>").replace(/\r/g, "<br>").replace(/\n/g, "<br>").replace(/\u2028/g, "<br>");
            else checkedValue = checkedValue.replace(/\n/g, "");
            checkedValue = checkedValue.replace(/"/g, "\\\"");
            if (this.replacePlaceholders) {
                if (this.replaceFullWidthPlaceholders) {
                    for (let i = 0; i < FULL_WIDTH_CHARACTERS.length; i++) {
                        checkedValue = checkedValue.replace(new RegExp(FULL_WIDTH_CHARACTERS[i], "g"), HALF_WIDTH_CHARACTERS[i]);
                    }
                }
                checkedValue = checkedValue.replace(/%(\d\$)?s/g, "%$1@");
            }
            if (!checkedValue && !this.retainEmptyValue) return;
            this.stringBuilder += `\t"${checkedKey}" => "${checkedValue}",\n`;
        }
    }

    addToZip(zip) {
        this.stringBuilder += "];";
        return zip.folder(this.languageCode).file(this.name ? `${this.name}.php` : IOS_RESOURCE_FILENAME.replace(".strings", ".php"), this.stringBuilder);
    }
}